import { Controller } from '@hotwired/stimulus';

export default class AccordionController extends Controller {
  static targets = ['header', 'content'];

  connect() {
    this.contentTargets.forEach((content) => {
      content.style.maxHeight = content.classList.contains('show')
        ? content.scrollHeight + 'px'
        : '0px';
    });
  }

  toggle(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const content = button
      .closest('.accordion-item')
      .querySelector('[data-accordion-target="content"]');

    // Close all other accordion items in this accordion
    this.contentTargets.forEach((target) => {
      if (target !== content) {
        target.style.maxHeight = '0px';
        target.classList.remove('show');
        target
          .closest('.accordion-item')
          .querySelector('.accordion-button')
          .classList.add('collapsed');
      }
    });

    // Toggle current accordion item
    button.classList.toggle('collapsed');
    content.classList.toggle('show');

    // Animate height
    if (content.classList.contains('show')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0px';
    }
  }
}
